import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Select2 from 'react17-select2-wrapper';
import defer from 'lodash/defer';

class Select2WithLabel extends Component {
  constructor (props) {
    super(props);
    this.select2Instance = createRef();
    this.state = { val: props.value };
  }

  componentDidMount () {
    this.sync();
  }

  componentDidUpdate () {
    this.sync();
  }

  onOpen () {
    this.addDropdownClass();
    this.addPlaceholder();

    if (typeof this.props.onOpen === 'function') {
      this.props.onOpen(this.select2Instance.current.el);
    }

    // Same as $screen-md in app/assets/stylesheets/doctor-of-my-dreams/variables/_layout.scss
    if (window.matchMedia('(max-width: 62em)').matches) {
      defer(() => {
        this.select2Instance.current.el[0].scrollIntoView();
      });
    }
  }

  syncUiStateWithValue () {
    const { el } = this.select2Instance.current;
    if (!el) return false;
    const parentEl = el[0].parentElement;
    if (!parentEl) return false;

    // react17-select2-wrapper doesn't update this on select like it should
    if (this.state.val) {
      return parentEl
        .getElementsByClassName('select2-container')[0]
        .classList.add('select2--has-option-selected');
    }

    return parentEl
      .getElementsByClassName('select2-container')[0]
      .classList.remove('select2--has-option-selected');
  }

  updateStateAndSync () {
    this.setState(
      { val: this.props.value },
      this.syncUiStateWithValue,
    );
  }

  sync () {
    if (this.props.value === this.state.val) {
      this.syncUiStateWithValue();
    } else {
      this.updateStateAndSync();
    }
  }

  addPlaceholder () {
    const { placeholder } = this.props;
    if (!placeholder) return;
    this.select2Instance.current.el
      .data('select2')
      .dropdown
      .$search
      .attr('placeholder', placeholder);
  }

  addDropdownClass () {
    const { dropdownClass } = this.props;
    if (!dropdownClass) return;
    this.select2Instance.current.el
      .data('select2')
      .$dropdown
      .addClass(dropdownClass);
  }

  render () {
    const {
      data,
      value,
      onSelect,
      selectId,
      required,
      disabled,
      labelText,
      labelClass,
      selectName,
      selectClass,
      noTypeahead,
      selectWrapperClass,
      options,
    } = this.props;

    const { templateResult } = options;

    return (
      <div
        data-value={value}
        data-disabled={disabled}
        className={`
          ${selectWrapperClass}
          ${noTypeahead ? 'opt-select--no-typeahead' : ''}
        `}
      >
        <Select2
          data={data}
          value={value}
          id={selectId}
          name={selectName}
          required={required}
          className={selectClass}
          ref={this.select2Instance}
          options={{
            disabled,
            templateResult,
            minimumResultsForSearch: noTypeahead ? Infinity : 0,
          }}
          onOpen={() => {
            this.onOpen();
          }}
          onSelect={(e) => {
            const val = e.target.value;
            onSelect(val);
            this.setState({ val }, () => {
              this.syncUiStateWithValue();
            });
          }}
        />
        {
          this.props.labelText && this.props.labelClass &&
            <label
              htmlFor={selectName}
              className={labelClass}
            >
              { `${labelText}${required ? '*' : ''}`}
            </label>
        }
      </div>
    );
  }
}

Select2WithLabel.propTypes = {
  onOpen: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  noTypeahead: PropTypes.bool,
  labelText: PropTypes.string,
  labelClass: PropTypes.string,
  placeholder: PropTypes.string,
  dropdownClass: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selectId: PropTypes.string.isRequired,
  selectName: PropTypes.string.isRequired,
  selectClass: PropTypes.string.isRequired,
  selectWrapperClass: PropTypes.string.isRequired,
  options: PropTypes.shape({
    dropdownCssClass: PropTypes.string,
    templateResult: PropTypes.func,
  }),
  data: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ])).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

Select2WithLabel.defaultProps = {
  options: {},
};

export default Select2WithLabel;
